export function getFormattedContact(value: string) {
  if (!value) {
    return;
  }
  const formatValue = value?.startsWith('+') ? value : `+${value}`;
  return formatValue;
}
